import { gql, useQuery } from '@apollo/client';
import { Organization } from '../typescript/apolloDataTypes';

const CURRENT_QUERY = gql`
  {
    currentUser @client {
      organizations {
        id
      }
      role
    }
    currentOrganization @client {
      id
    }
    userIsPreviewing @client
  }
`;

export const useRailsContextApolloData = () => {
  const { data } = useQuery(CURRENT_QUERY);
  if (!data)
    return {
      userCanEdit: false,
      userIsEditing: false,
      userIsPreviewing: true,
    };

  const { currentOrganization, userIsPreviewing, currentUser } = data;
  const userCanEdit = Boolean(
    currentOrganization &&
      currentUser &&
      (currentUser.role === 'admin' ||
        (currentUser.role === 'organizer' &&
          currentUser.organizations
            .map((organization: Organization) => organization.id)
            .includes(currentOrganization.id)))
  );
  const userIsEditing = userCanEdit && !userIsPreviewing;
  return {
    userCanEdit,
    userIsEditing,
    userIsPreviewing,
  };
};
